<template>
  <div>
    <b-row>
      <b-col cols="12">
        <div>
          <spinner v-if="activateSpinner"></spinner>
          <b-table v-else-if="listItems.length > 0"
            :items="listItems"
            :fields="fields"
            :sort-by.sync="sortBy"
            class="table-striped"
            fixed hover :selectable="listItems.length > 0"
            :empty-text="$t('common.security.no_result')"
            @row-selected="onRowSelected">
            <template #cell(name)="data">
              <span>{{ data.value }}</span>
            </template>
            <template #cell(type)="data">
              <span>{{ data.value }}</span>
            </template>
            <template #cell(active)="data">
              <i v-if="data.value == 1" class="fa-regular fa-circle-check cursor color-var-actionButtonColorBlue"></i>
              <i v-if="data.value == 2" class="fa-regular fa-circle-xmark cursor text-danger"></i>
              <i v-if="data.value == 3" class="fa-solid fa-triangle-exclamation cursor text-warning"></i>
              <svg v-if="data.value == 4"
                  width="12px"
                  height="14px"
                  viewBox="0 0 32.07053 40.365376"
                  version="1.1"
                  id="svg1"
                  xml:space="preserve"
                  xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
                  xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:svg="http://www.w3.org/2000/svg"><sodipodi:namedview
     id="namedview1"
     pagecolor="#ffffff"
     bordercolor="#000000"
     borderopacity="0.25"
     inkscape:showpageshadow="2"
     inkscape:pageopacity="0.0"
     inkscape:pagecheckerboard="0"
     inkscape:deskcolor="#d1d1d1"
     inkscape:document-units="mm" /><defs
                  id="defs1" /><g
                  inkscape:label="Calque 1"
                  inkscape:groupmode="layer"
                  id="layer1"
                  transform="translate(-124.57853,-104.79531)"><path
       style="fill:#6c757d"
       d="m 127.25978,145.00538 c -0.45406,-0.1773 -0.85947,-0.54183 -1.09536,-0.9849 -0.22163,-0.41631 -0.23972,-1.36693 -0.0338,-1.77485 0.0767,-0.15185 0.9153,-1.34099 1.86363,-2.64255 l 1.72424,-2.36646 -0.68297,-0.7147 c -5.06603,-5.30141 -5.90765,-13.36707 -2.03987,-19.54895 3.16887,-5.06481 8.94909,-8.01807 14.77198,-7.54738 2.08988,0.16894 3.9012,0.64805 5.70841,1.50992 0.53652,0.25587 1.00598,0.44638 1.04324,0.42335 0.0373,-0.023 0.87305,-1.1496 1.85729,-2.50349 2.64487,-3.63817 2.57373,-3.54875 3.01362,-3.78816 0.74696,-0.40655 1.54987,-0.35553 2.23253,0.14186 0.74545,0.54314 1.03565,1.70604 0.62321,2.49732 -0.0958,0.18377 -1.10499,1.61421 -2.24267,3.17876 -1.13769,1.56456 -2.09752,2.89263 -2.13297,2.95129 -0.0446,0.0737 0.0931,0.26844 0.44615,0.63105 2.17767,2.23653 3.71485,5.42737 4.20476,8.72814 0.17121,1.15347 0.17041,3.3406 -0.002,4.49627 -0.51847,3.48277 -2.07875,6.57754 -4.5744,9.07319 -3.04491,3.04491 -7.00343,4.69337 -11.26488,4.69107 -2.43943,-0.001 -4.45175,-0.42422 -6.6431,-1.39611 -0.43385,-0.19242 -0.82798,-0.36688 -0.87584,-0.38769 -0.0479,-0.0208 -0.87677,1.04701 -1.84201,2.37292 -0.96523,1.32591 -1.88449,2.51787 -2.04278,2.64881 -0.32042,0.26503 -0.91849,0.47211 -1.34732,0.46648 -0.15482,-0.002 -0.45609,-0.0719 -0.66949,-0.15519 z m 15.01049,-7.77316 c 7.10553,-1.04017 11.66693,-7.88525 9.8793,-14.82541 -0.42902,-1.6656 -1.38199,-3.47248 -2.51282,-4.76443 l -0.30376,-0.34704 -6.82424,9.37903 c -3.75334,5.15846 -6.84862,9.41974 -6.87842,9.4695 -0.12765,0.21319 2.30165,0.97629 3.57366,1.12257 0.96094,0.11051 2.16975,0.097 3.06628,-0.0342 z m -3.14023,-12.92436 c 6.31248,-8.67496 6.87048,-9.46657 6.74007,-9.56193 -0.23265,-0.17011 -1.22186,-0.55971 -1.97611,-0.77828 -2.33429,-0.67646 -5.00232,-0.58553 -7.3168,0.24934 -4.7224,1.70347 -7.86783,6.19461 -7.86282,11.22678 0.003,2.95875 0.99816,5.58868 2.97886,7.87184 0.23685,0.27301 0.45851,0.48599 0.49259,0.47329 0.0341,-0.0127 3.15897,-4.27916 6.94421,-9.48104 z"
       id="path1" /></g></svg>

            </template>
          </b-table>
          <div v-else class="d-flex justify-content-center">
            <span class="noResult">
              {{ $t('common.no_result') }}
            </span>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import Spinner from '@/components/common/spinner.vue'

import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'SecuritySSHList',
  components: {
    'form-write-group-label-input':formWriteGroupLabelInput,
    'spinner': Spinner
  },
  props: {
    typeList: {
      Type: String,
      default: 'none'
    }
  },
  computed: {
    canAdd () {
      return true
      // return this.$engine.rights.rightIs(this.typeList + '_ajouter', true)
    },
    canEdit () {
      return true
      // return this.$engine.rights.rightIs(this.typeList + '_editer', true)
    },
    canDelete () {
      return true
      // return this.$engine.rights.rightIs(this.typeList + '_supprimer', true)
    },
    fields () {
      let fields = []

      fields.push({
        key: 'name',
        label: this.$t('common.nme'),
        thClass: 'text-center table-condensed-ipad',
        tdClass: 'p-0 text-center w-100 p-2 py-3',
        sortable: true
      })
      fields.push({
        key: 'pod',
        label: 'Pod',
        thClass: 'text-center table-condensed-ipad',
        tdClass: 'p-0 text-center w-100 p-2 py-3',
        sortable: true
      })
      if (this.canEdit) {

      }
      /* if (this.canDelete) {

      } */
      return fields
    },
    tableTitle () {
      switch (this.typeList) {
        case 'ca':
          this.ajouterButtonTitle = 'add_ca'
          this.searchPlaceholder = 'ca'
          return 'ca'
        case 'certificate':
          this.ajouterButtonTitle = 'add_cert'
          this.searchPlaceholder = 'cert'
          return 'cert_name'
        case 'configuration':
          this.ajouterButtonTitle = 'add_config'
          this.searchPlaceholder = 'configuration'
          return 'configuration'
        case 'configurationSSL':
          this.ajouterButtonTitle = 'add_configSSL'
          this.searchPlaceholder = 'configurationSSL'
          return 'configurationSSL'
        case 'configurationSMIME':
          this.ajouterButtonTitle = 'add_configSMIME'
          this.searchPlaceholder = 'configurationSMIME'
          return 'configurationSMIME'
        case 'privatekey':
          this.ajouterButtonTitle = 'add_private_key'
          this.searchPlaceholder = 'priv_key'
          return 'priv_ks'
        case 'keystore':
          this.ajouterButtonTitle = 'add_key_store'
          this.searchPlaceholder = 'key_store'
          return 'key_store'
        default:
          return ''
      }
    }
  },
  data () {
    return {
      activateSpinner: false,
      ajouterButtonTitle: '',
      changeType: false,
      elementSearchedCA: '',
      elementSearchedCertif: '',
      elementSearchedConfig: '',
      elementSearchedConfigSSL: '',
      elementSearchedConfigSMIME: '',
      elementSearchedPrivKeys: '',
      listItems: [],
      right: [],
      searchPlaceholder: '',
      sortBy: 'name'
    }
  },
  created () {
    this.activateSpinner = true
    this.getSSH()
  },
  methods: {
    actionAdd () {
      loadPage(this, { url: '/security/' + this.typeList + '/add/-1'})
    },
    actionDelete ($e, id) {
      $e.stopPropagation()
      let that = this
      this.$f7.modal({
        title: this.$t('common.security.element_deletion_confirm'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              let params = {
                id: id
              }
              if(that.typeList === 'ca') {
                that.$engine.security.ca.delete(params)
                .then(resp => {
                  that.$f7.modal({
                    title: that.$t('common.security.ca_deleted'),
                    buttons: [
                      {
                        text: 'OK',
                        onClick: function () {
                          return
                        }
                      }
                    ]
                  })
                  loadPage(that, {url: '/security/0'})
                })
                .catch(e => {
                  errorMessageAlert(e, that, that.$i18n)
                  that.okMessageBox(that.$t('common.security.cert_delete_error'))
                })
              }
              if (that.typeList === 'certificate') {
                that.$engine.security.certificates.delete(params)
                .then(resp => {
                  that.$f7.modal({
                    title: that.$t('common.security.cert_deleted'),
                    buttons: [
                      {
                        text: 'OK',
                        onClick: function () {
                          return
                        }
                      }
                    ]
                  })
                  loadPage(that, {url: '/security/1'})
                })
                .catch(e => {
                  errorMessageAlert(e, that, that.$i18n)
                  that.okMessageBox(that.$t('common.security.cert_delete_error'))
                })
              }
              if (that.typeList === 'privatekey') {
                that.$engine.security.private_keys.delete(params)
                .then(resp => {
                  that.$f7.modal({
                    title: that.$t('common.security.priv_key_deleted'),
                    buttons: [
                      {
                        text: 'OK',
                        onClick: function () {
                          return
                        }
                      }
                    ]
                  })
                  loadPage(that, {url: '/security/2'})
                })
                .catch(e => {
                  errorMessageAlert(e, that, that.$i18n)
                  that.okMessageBox(that.$t('common.security.priv_key_delete_error'))
                })
              } else {
                return
              }
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    actionDetails (id) {
      loadPage(this, { url: '/security/ssh/view/' + id })
    },
    actionEdit ($e, id) {
      $e.stopPropagation()
      if (this.typeList === 'configuration' || this.typeList === 'configurationSSL' || this.typeList === 'configurationSMIME') {
        const idPod = id.split(';')[1]
        const type = id.split(';')[2]
        id = id.split(';')[0]
        loadPage(this, { url: '/security/' + 'configuration' + '/edit/' + id + '/' + idPod + '/' + type })
      } else {
        loadPage(this, { url: '/security/' + this.typeList + '/edit/' + id })
      }
    },
    applyFilters (typeList) {
      this.activateSpinner = true
      switch (typeList) {
        case 'ca':
          this.getCA()
          break
        case 'certificate':
          this.getCertificates()
          break
        case 'configuration':
          this.getConfigurations()
          break
        case 'configurationSSL':
          this.getConfigurationsSSL()
          break
        case 'configurationSMIME':
          this.getConfigurationsSMIME()
          break
        case 'privatekey':
          this.getPrivateKeys()
          break
        default:
          return ''
      }
    },
    emptyFilters (typeList) {
      this.activateSpinner = true
      switch (typeList) {
        case 'ca':
          this.elementSearchedCA = ''
          this.getCA()
          break
        case 'certificate':
         this.elementSearchedCertif = ''
          this.getCertificates()
          break
        case 'configuration':
          this.elementSearchedConfig = ''
          this.getConfigurations()
          break
        case 'configurationSSL':
          this.elementSearchedConfigSSL = ''
          this.getConfigurationsSSL()
          break
        case 'configurationSMIME':
          this.elementSearchedConfigSMIME = ''
          this.getConfigurationsSMIME()
          break
        case 'privatekey':
          this.elementSearchedPrivKeys = ''
          this.getPrivateKeys()
          break
        default:
          return ''
      }
    },
    getSSH () {
      let that = this

      this.$engine.security.ssh.fetch()
      .then(resp => {
        let SSHList = {}

        SSHList = resp.data.ssh
        for (let i = 0; i < SSHList.length; i++) {
          SSHList[i].delete = SSHList[i].id
          SSHList[i].edit = SSHList[i].id
        }
        that.updateSSH(SSHList)

        this.$f7.pullToRefreshDone()
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    onRowSelected (items) {
      this.actionDetails(items[0].id)
    },
    updateSSH (SSHList) {
      this.listItems = SSHList
    },
    updateCertificates (certificatesList) {
      if (this.typeList === 'certificate') {
        this.listItems = certificatesList
      }
    },
    updateConfigurations (configurationsList) {
      if (this.typeList === 'configuration') {
        this.listItems = configurationsList
      }
    },
    updateConfigurationsSSL (configurationsListSSL) {
      if (this.typeList === 'configurationSSL') {
        this.listItems = configurationsListSSL
      }
    },
    updateConfigurationsSMIME (configurationsListSMIME) {
      if (this.typeList === 'configurationSMIME') {
        this.listItems = configurationsListSMIME
      }
    },
    updatePrivateKeys (privateKeysList) {
      if (this.typeList === 'privatekey') {
        this.listItems = privateKeysList
      }
    },
    updateKeyStore (keyStoreList) {
      if (this.typeList === 'keystore') {
        this.listItems = keyStoreList
      }
    }
  }
}

</script>
